export const ChartName = {
    TABLE_DATA: 'Table Chart',
    BAR_CHART: 'Bar Chart',
    ROSE_CHART: 'Rose Chart',
    AVERAGE_CHART: 'Average Response',
    MOST_COMMON_CHART: 'Most Common Response',
    WORD_CLOUD_CHART: 'Word Cloud',
    WORD_COUNT_CHAR: 'Word Count',
    RESPONSE_CLOUD_CHART: 'Response Cloud',
    RESPONSE_COUNT_CHART: 'Response Count'
}

export const CompareChartName = {
    PARALLEL: 'Compare by Line',
    DIFF: '% Difference',
    GAUGE: 'Gauge Ring',
    STACKED_BAR: 'Stacked Bar',
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/chart.constants.ts